<template>
  <div class="platform-notification-container" v-for="(notification, index) in platformNotifications" :key="index">
    <span class="router-container-with-notification__text" v-html="notification.message" />
    <BbBtn
      size="x-small"
      type="icon"
      icon="x-small"
      icon-size="medium"
      no-background
      class="router-container-with-notification__icon"
      @click="deleteNotificationCookies(notification.id)"
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import usePlatformNotifications from '~/composables/usePlatformNotifications';
import { useSanitize } from '~/composables/useSanitize';

export default {
  name: 'PlatformNotifications',
  setup() {
    const { deleteNotificationCookies, platformNotifications } = usePlatformNotifications();
    const { sanitize } = useSanitize();

    const sanitizedNotifications = computed(() =>
      platformNotifications.value.map((item) => ({
        ...item,
        message: sanitize(item.message),
      })),
    );

    return {
      platformNotifications: sanitizedNotifications,
      deleteNotificationCookies,
    };
  },
};
</script>

<style lang="scss">
.platform-notification-container {
  height: 32px;
  border-bottom: 1px solid $bb-neutral-4;
  background: #ffd853;
  font-size: 15px;
  color: #1a1a1a;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 38px;

  .router-container-with-notification__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  .router-container-with-notification__icon {
    position: absolute;
    top: 4px;
    right: 16px;
  }
}
</style>
